import { h } from 'preact';
import { t } from '../../theme/locales';
// Helper: determine if a line item has been embroidered (has an embroidery child)
export const isEmbroideryProduct = (item)=>{
    return !!((item === null || item === void 0 ? void 0 : item.properties) || {})._embroidery_id;
};
// Helper: determine if an item is an embroidery personalization product (child of an embroidered item)
export const isEmbroideryPersonalizationProduct = (item)=>{
    return !!((item === null || item === void 0 ? void 0 : item.properties) || {})._embroidery_parent_id;
};
// Helper: find the embroidery personalization cart item for a given parent item.
// Returns the raw CartItem (useful for accessing price, quantity, etc.), or null if not found.
export const getEmbroideryPersonalizationItem = (item, cartItems)=>{
    var _item_properties;
    if (!isEmbroideryProduct(item)) return null;
    var _item_properties__embroidery_id;
    const embroideryId = String((_item_properties__embroidery_id = (_item_properties = item.properties) === null || _item_properties === void 0 ? void 0 : _item_properties._embroidery_id) !== null && _item_properties__embroidery_id !== void 0 ? _item_properties__embroidery_id : '');
    if (embroideryId === '') return null;
    var _cartItems_find;
    return (_cartItems_find = cartItems.find((it)=>{
        var _it_properties;
        return isEmbroideryPersonalizationProduct(it) && String((_it_properties = it.properties) === null || _it_properties === void 0 ? void 0 : _it_properties._embroidery_parent_id) === embroideryId;
    })) !== null && _cartItems_find !== void 0 ? _cartItems_find : null;
};
// Helper: map a raw personalization CartItem to EmbroideryProductDetails.
export const mapPersonalizationItem = (personalizationItem)=>{
    const props = personalizationItem.properties;
    var _props_Text, _props_Color, _props_Category, _props_Font;
    return {
        text: String((_props_Text = props === null || props === void 0 ? void 0 : props.Text) !== null && _props_Text !== void 0 ? _props_Text : ''),
        color: String((_props_Color = props === null || props === void 0 ? void 0 : props.Color) !== null && _props_Color !== void 0 ? _props_Color : ''),
        font_category: String((_props_Category = props === null || props === void 0 ? void 0 : props.Category) !== null && _props_Category !== void 0 ? _props_Category : ''),
        font_style: String((_props_Font = props === null || props === void 0 ? void 0 : props.Font) !== null && _props_Font !== void 0 ? _props_Font : ''),
        price: personalizationItem.final_line_price
    };
};
// Helper: find the embroidery personalization product for a given item and return its mapped properties.
// The parent item carries `_embroidery_id` (a string such as "embroidery_<rand>").
// The child carries `_embroidery_parent_id` set to that same string.
export const getEmbroideryProduct = (item, cartItems)=>{
    const personalizationItem = getEmbroideryPersonalizationItem(item, cartItems);
    return personalizationItem ? mapPersonalizationItem(personalizationItem) : null;
};
// Component: renders embroidery personalization details for a cart line item.
// Pass `details` when already computed to skip the cart lookup.
const EmbroideryDetails = ({ item , cartItems , details  })=>{
    if (!isEmbroideryProduct(item)) return null;
    const embroideryItem = details !== undefined ? details : getEmbroideryProduct(item, cartItems !== null && cartItems !== void 0 ? cartItems : []);
    return h('div', {
        className: 'gw-cart-subitem__embroidery'
    }, [
        h('span', {
            className: 'gw-cart-subitem__embroidery__label'
        }, `${t('gift_wrapping.embroidered')}: `),
        h('span', {
            className: 'gw-cart-subitem__embroidery__text'
        }, `"${(embroideryItem === null || embroideryItem === void 0 ? void 0 : embroideryItem.text) ? embroideryItem.text : ''}"`)
    ]);
};
export { EmbroideryDetails };
